/**
 * AstroBin serves timelapses and animations as videos, but the v1 API the
 * gallery is built on has no video fields, so these come from the v2 data the
 * backend merges in. Thumbnail URLs now point straight at AstroBin's CDN; the
 * `*_fallback` fields hold the original astrobin.com redirect URLs, which still
 * resolve if a CDN URL goes stale between refreshes.
 */

/**
 * Descriptive alt text for gallery images. Adds context beyond the bare title
 * to help image search, and never resolves to an empty attribute.
 */
export const buildImageAlt = (title) => (
    title ? `${title} — astrophotography by David Joyce` : 'Astrophotography by David Joyce'
);

export const getVideoUrl = (image) => image?.encoded_video_file || image?.video_file || '';

export const isVideoImage = (image) => Boolean(getVideoUrl(image));

export const shouldLoopVideo = (image) => Boolean(image?.loop_video);

/**
 * Swap a broken CDN thumbnail for the astrobin.com redirect URL. Guards
 * against a retry loop if the fallback is missing or also fails.
 */
export const handleThumbnailError = (event, fallbackUrl) => {
    const element = event.currentTarget;

    if (!fallbackUrl || element.dataset.fallbackApplied === 'true') {
        return;
    }

    element.dataset.fallbackApplied = 'true';
    element.src = fallbackUrl;
};
